export const getTasaDeCambio = (network, selectedTokenSymbol) => {
  if (selectedTokenSymbol === 'USDT') {
    return parseFloat(process.env.REACT_APP_USDT_RATE || 1);
  }
  if (selectedTokenSymbol === 'USDC') {
    return parseFloat(process.env.REACT_APP_USDC_RATE || 1);
  }

  if (network && Number(network.chainId) === 1) { // Mainnet
    return parseFloat(process.env.REACT_APP_MAINNET_EXCHANGE_RATE || 0.1);
  } else if (network && Number(network.chainId) === 56) { // BSC
    return parseFloat(process.env.REACT_APP_BSC_EXCHANGE_RATE || 100);
  } else if (network && Number(network.chainId) === 97) { // BNB Testnet
    return parseFloat(process.env.REACT_APP_BNB_TESTNET_EXCHANGE_RATE || 0.02);
  } else if (network && Number(network.chainId) === 137) { // Polygon
    return parseFloat(process.env.REACT_APP_POLYGON_EXCHANGE_RATE || 0.5);
  } else if (network && Number(network.chainId) === 42161) { // Arbitrum
    return parseFloat(process.env.REACT_APP_ARBITRUM_EXCHANGE_RATE || 0.1);
  } else if (network && Number(network.chainId) === 8453) { // Base
    return parseFloat(process.env.REACT_APP_BASE_EXCHANGE_RATE || 0.1);
  } else { // Sepolia
    const rate = parseFloat(process.env.REACT_APP_SEPOLIA_EXCHANGE_RATE || 0.022);
    // console.log('Sepolia rate:', rate, 'env value:', process.env.REACT_APP_SEPOLIA_EXCHANGE_RATE);
    return rate;
  }
};
